import { MobileContentGems } from '@mc/api'
import { StickyCardDesktop } from './StickyCard'

export const ContentDesktop = ({
  mobileContentGems,
}: {
  mobileContentGems: MobileContentGems[]
}) => (
  <div className='row no-gutters' style={{ margin: -8 }}>
    {mobileContentGems.map((gem, index) => (
      <StickyCardDesktop key={gem.id} gem={gem} index={index} />
    ))}
  </div>
)
